import React from 'react';
import { ParameterStatusUtil } from '../../../api';
import { RequestInfoForm, StatusForm } from '../../../components/Forms';
import { CreateWorkflow } from '../../../components/Common/CreateWorkflow';
import { useFormContext } from 'react-ocean-forms';
import { ViewConfig } from '../../../components';
import { ParameterMandatoryForm, ParameterOptionalForm } from '../../../components/Parameter';

interface ParameterNewEditFormProps {
  viewConfig: ViewConfig;
  updateWorkflow?: (workflow: CreateWorkflow) => void;
}

/**
 * @author Jungwirth
 */
export const ParameterNewEditForm: React.FC<ParameterNewEditFormProps> = (props: Readonly<ParameterNewEditFormProps>): JSX.Element | null => {
  
  const {
    viewConfig,
    updateWorkflow = () => {}
  } = props;

  const form = useFormContext();

  form.registerListener('formChanges', (name, event, args) => {
    updateWorkflow(CreateWorkflow.CheckDuplicates);
  });

  return (
    <React.Fragment>
      <ParameterMandatoryForm
        viewConfig={viewConfig} />
      <ParameterOptionalForm
        viewConfig={viewConfig} />
      <RequestInfoForm
        name="anforderung"
        viewConfig={viewConfig.fields}
      />
      <StatusForm
        name="status"
        label="status"
        right
        viewConfig={viewConfig}
        statusUtil={ParameterStatusUtil}
      />
    </React.Fragment>
  );
};
